import { styled, css } from '@mui/material/styles';

interface SplitBackgroundProps {
  topBackgroundColor: string;
  topBackgroundImageUrl: string | null;
}

export const SplitBackgroundContainer = styled('div')<SplitBackgroundProps>`
  .root {
    &:before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 50vh;
      z-index: 1;
      background-color: ${(props) => props.topBackgroundColor};
      background-image: ${(props) =>
        props.topBackgroundImageUrl ? `url("${props.topBackgroundImageUrl}")` : 'none'};
    }
  }
`;

const ABSOLUTE = css`
  position: absolute;
  overflow: hidden;
  left: 0;
  right: 0;
`;

interface BGContainerProps {
  middle: boolean;
}

export const BackgroundContainer = styled('div')<BGContainerProps>`
  ${ABSOLUTE};
  top: ${(props) => (props.middle ? 0 : 'initial')};
  bottom: ${(props) => (props.middle ? 'initial' : 0)};
  height: ${(props) => (props.middle ? '50vh' : '100%')};
`;

export const SmokeWrapper = styled('div')`
  position: absolute;
  padding-top: 32.247%; // intrinsic ratio of smoke image
  left: 0;
  bottom: 0;
  transform: translateY(35%);
  opacity: 0.8;
  z-index: 100;
  width: 800px;
  ${(props) => props.theme.breakpoints.up('sm')} {
    width: 100%;
    transform: translateY(30%);
  }
`;

const IMG = css`
  width: 110%;
  position: absolute;
  bottom: 0;

  img {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
  }

  &:nth-of-type(2) img {
    transform: scaleX(-1);
  }
`;

export const SmokeImage1 = styled('div')`
  ${IMG};
  left: 0;
  right: auto;
`;

export const SmokeImage2 = styled('div')`
  ${IMG};
  left: auto;
  right: 0;
`;

export const Container = styled('div')`
  position: relative;
  z-index: 101;
`;
